@use "@styles/_variables/colors" as *;
@use "@styles/_variables/breakpoints" as *;
@use "@styles/_variables/sizes" as *;

.tab {
  margin-bottom: $tab-double;
  overflow: hidden;
  transition: 1s;
  position: relative;

  .tab-body {
    font-size: 4vw;
    transition: all 1s ease-in-out;
    // Top clears the frame's title band (corner = w/8); sides/bottom hug the frame.
    padding: 16vw 3vw 5vw 3vw;
    overflow: hidden;
    color: $main-lightestest;
    @media all and (max-width: $mobile-large) {
      padding: 6vw 4vw 5vw 4vw;
    }
    @media all and (min-width: $desktop-medium) {
      padding: 20rem 4rem 6rem 4rem;
    }
  }

  .frame {
    width: 100%;
    height: 100%;
    user-select: none;
    position: absolute;
    transition: all 1s ease-in-out;
    color: path {
      transition: all 0.3s linear;
    }
    svg {
      transition: all 1s ease-in-out;
      text {
        transition: all 0.3s ease-in-out;
        user-select: none;
        // Size comes from the component's width-proportional fontSize
        // attribute (corner * 0.5), so the title stays in constant proportion
        // to the frame at every width; hover deliberately no longer grows the
        // type.
        fill: $main-lightest;
        text-shadow: $text-glow-faint;
        // pointer-events: none;
        &:hover {
          fill: $main-lightestest;
          text-shadow: $text-glow-strong;
        }
      }
      .frame-title {
        animation:
          frame-title-boot 0.55s linear,
          frame-title-pulse 2.8s ease-in-out 0.55s infinite alternate;
        &:hover {
          animation: none;
        }
      }
      // The traveling gold glint. The band is swept by animating the
      // gradient-filled rect's own transform: WebKit ignores SMIL
      // animateTransform on gradientTransform, so moving the element is
      // the only route that runs in Safari. translateX percentages are
      // fractions of the rect's fill-box, matching the old objectBoundingBox
      // translate(-1.15 -> 1.15). Decorative; dropped for reduced motion.
      .frame-sweep {
        transform-box: fill-box;
        animation: frame-sweep-travel 5.5s linear infinite;
        @media (prefers-reduced-motion: reduce) {
          display: none;
        }
      }
    }
  }
}

@keyframes frame-title-boot {
  0% {
    opacity: 0;
    text-shadow: $text-glow-strong;
  }
  15% {
    opacity: 1;
  }
  30% {
    opacity: 0.3;
  }
  45% {
    opacity: 0.85;
  }
  60% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
    text-shadow: $text-glow-faint;
  }
}

@keyframes frame-title-pulse {
  0% {
    text-shadow: $text-glow-faint;
  }
  100% {
    text-shadow: $text-glow;
  }
}

@keyframes frame-sweep-travel {
  from {
    transform: translateX(-115%);
  }
  to {
    transform: translateX(115%);
  }
}
